import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import Link from '../Link'

export default ({ title, components }) => {
  const intl = useIntl()

  const ctaDownload = intl.formatMessage({ id: 'cta.download' })

  return (
    <div className="wrapper">
      <div className={styles.container}>
        <GradientBorder height="1px" className={styles.gradBorder} />
        <h2>{title}</h2>
        <div className={styles.resources}>
          {components.map((component, idx) => (
            <div className={styles.block} key={idx}>
              <div className={styles.textSection}>
                <h3 className={styles.text}>{component.title}</h3>
                <div className={styles.subtext}>
                  {component.subtitle.subtitle}
                </div>
              </div>
              <div className={styles.buttonBox}>
                <Link to={component.ctaUrl} target="_blank">
                  <Button className={styles.downloadButton} inverted>
                    {component.ctaText ? component.ctaText : ctaDownload}
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
